<!-- Filter Datatables -->
<section id="ngx-datatable-filter">
    <div class="row">
      <div class="col-12"></div>
      <div class="col-12">
        <div class="card">
          <div class="card-content">
            <div class="card-body">
              <!-- ngx-datatable-filter -->
              <fieldset class="form-group">
                <div class="row align-items-end mt-0 pagination-body">
  
                  <div class="col-12 col-sm-12 col-md-6 col-lg-6 ">
                    <div class="btn-group enrollment-list-btn-info" role="group">
                      <button class="btn enrollment-list-buttons" type="button" *ngFor="let status of task_status_list"
                        [ngClass]="{'btn-primary':activeTab==status?.name,'btn-outline-primary':activeTab!=status?.name}"
                        (click)="activeEmployeeTab(status?.name)">{{status.displayname}}</button>
                    </div>
                  </div>
                  <div class="col-12 col-sm-12 col-md-6 col-lg-6  ">
                    <div class="row-flex">
                      <div class="col-flex-2">
                        <div ngbDropdown>
                          <button type="button" class="btn btn-outline-primary btn2" id="dropdownBasic5" ngbDropdownToggle
                            [value]="selected_check_id">{{selected_check_name}}</button>
                          <div ngbDropdownMenu aria-labelledby="dropdownBasic5">
                            <a class="dropdown-item " *ngFor="let item of check_list"
                              (click)="getCheckTypeId(item?._id,item?.displayname)">{{item?.displayname}}</a>
                          </div>
                        </div>
                      </div>
  
                      <div class="col-flex-2">
                        <button class="btn btn-outline-primary" placement="top" ngbTooltip="Add New"
                          (click)="openModalAddCheckList(addCheckListModal)">+</button>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-sm-12 col-md-12 col-lg-12 pagination-body header-body mb-2">
                    <ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="40"
                      [footerHeight]="40" rowHeight="auto" [limit]="limitRef" [rows]="rows" [externalPaging]="true"
                      [count]="page.totalPages" [offset]="page.pageNumber" (page)="pageChangeData($event)">
                      <ngx-datatable-footer>
                        <ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize">
                          <div class="datatable-footer-inner">
                            <div class="total-count">
                              <span>Total : {{page.totalPages}}</span>
                            </div>
                          </div>
                        </ng-template>
                      </ngx-datatable-footer>
  
                    </ngx-datatable>
                  </div>
                </div>
                <div class="row align-items-end mt-0 pagination-body mb-2">
                  <div class="col-12 col-sm-12 col-md-12 col-lg-12  ">
                    <div class="row-flex filter-tabs">
                      <div class="col-flex-2 filter">
                        <ng-select [items]="empList" bindLabel="name" bindValue="_id" placeholder="Select User"
                          [(ngModel)]="selected_user_id" [ngModelOptions]="{ standalone: true }"
                          (change)="getUserId($event)">
                        </ng-select>
                        <!-- <div ngbDropdown>
                            <button class="btn btn-outline-primary mr-1" id="dropdownBasic1" ngbDropdownToggle>{{selected_user_name}}</button>
                            <div ngbDropdownMenu aria-labelledby="dropdownBasic1" >
                              <button class="dropdown-item" *ngFor="let user of empList " (click)="getUserId(user?._id,user?.name)">{{user?.name}}</button>
                            </div>
                          </div> -->
                      </div>
                      <div class="col-flex-2 filter">
                        <ng-select [items]="task_priority_List" bindLabel="displayname" bindValue="_id"
                          placeholder="Select User" [(ngModel)]="selected_priority_id"
                          [ngModelOptions]="{ standalone: true }" (change)="getPriorityId($event)">
                        </ng-select>
                        <!-- <div ngbDropdown>
                            <button type="button" class="btn btn-outline-primary btn2" id="dropdownBasic2" ngbDropdownToggle>{{selected_priority_name}}</button>
                            <div ngbDropdownMenu aria-labelledby="dropdownBasic2">
                              <a class="dropdown-item " *ngFor="let priority of task_priority_List"
                                (click)="getPriorityId(priority?._id,priority?.displayname)">{{priority?.displayname}}</a>
                            </div>
                          </div> -->
                      </div>
                      <div class="col-flex-2 filter">
                        <!-- <ng-select [items]="taskLabelList" bindLabel="displayname" bindValue="_id"
                          placeholder="Select User" [(ngModel)]="selected_label_id"
                          [ngModelOptions]="{ standalone: true }" (change)="getLabelId($event)">
                        </ng-select> -->
                        <ng-select [items]="scheduleList" bindLabel="name" bindValue="id" placeholder="Select Schedule"
                          [(ngModel)]="selectedSchedule_filter" [ngModelOptions]="{ standalone: true }" (change)="getChangeScheduleId($event)">
                        </ng-select>
                        <!-- <div ngbDropdown>
                            <button type="button" class="btn btn-outline-primary btn2" id="dropdownBasic3" ngbDropdownToggle>{{selected_label_name}}</button>
                            <div ngbDropdownMenu aria-labelledby="dropdownBasic3">
                              <a class="dropdown-item " *ngFor="let label of taskLabelList"
                                (click)="getLabelId(label?._id,label?.displayname)">{{label?.displayname}}</a>
                            </div>
                          </div> -->
                      </div>
                      <div class="col-flex-2 filter">
                        <ng-select [items]="task_stage_list" bindLabel="displayname" bindValue="_id"
                          placeholder="Select User" [(ngModel)]="selected_stage_id"
                          [ngModelOptions]="{ standalone: true }" (change)="getStageId($event)">
                        </ng-select>
                        <!-- <div ngbDropdown>
                            <button type="button" class="btn btn-outline-primary btn2" id="dropdownBasic4" ngbDropdownToggle>{{selected_stage_name}}</button>
                            <div ngbDropdownMenu aria-labelledby="dropdownBasic4">
                              <a class="dropdown-item " *ngFor="let stage of task_stage_list"
                                (click)="getStageId(stage?._id,stage?.displayname)">{{stage?.displayname}}</a>
                            </div>
                          </div> -->
                      </div>
                      <div class="col-flex-2">
                        <button class="btn btn-outline-primary" (click)="resetFilter()">Reset Filter</button>
                      </div>
                      <div class="col-flex-2">
                        <button data-toggle="collapse" data-target="#demo" class="btn btn-outline-primary" (click)="toggleCollapse()" [attr.aria-expanded]="isCollapsed ? 'false' : 'true'">{{ isCollapsed ? 'Collapse' : 'Expand' }}</button>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 mt-1">
                    <button *ngIf="guideline_data" class="btn btn-outline-primary" (click)="openDynamicModal(guideline_data)">Tracker Guideline</button>
                  </div>
                </div>
              </fieldset>
              <div *ngFor="let list of rows;let i=index">
                <div class="main_heading cursor-pointer"  (click)="collapse.toggle()" [attr.aria-expanded]="taskView[i]"
                  aria-controls="collapseExample">
                  <!-- <h3>{{list?.label?.displayname}}</h3> -->
                  <h5 [ngClass]="{'bg-light-info badge ': list?.label?.displayname =='Assignment',
                    'bg-light-warning badge': list?.label?.displayname =='Events',
                    'bg-light-danger badge ': list?.label?.displayname =='Leave',
                      'bg-light-primary badge': list?.label?.displayname =='Demo'}">{{list?.label?.displayname
                    ||list?._id}} ({{list?.total}})</h5>
                </div>
                
                  <ngx-datatable id="demo" #collapse="ngbCollapse" [(ngbCollapse)]="taskView[i]" class="bootstrap core-bootstrap collapse"
                    [columnMode]="ColumnMode.force" [headerHeight]="50" [footerHeight]="50" rowHeight="auto"
                    [limit]="limitRef" [rows]="list?.tasks" [scrollbarH]="true" [columns]="columns">
                    <ngx-datatable-column name="Title" prop="title" [width]="100">
                      <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                        <div class="d-flex align-items-center">
                          <div class="cell-line-height">
                            <p [ngClass]="{'bg-light-info badge ': list?.label?.displayname =='Assignment'}"
                              *ngIf="list?.label?.displayname =='Assignment'">{{list?.label?.displayname}}</p>
                            <p [ngClass]="{'bg-light-warning badge': list?.label?.displayname =='Events'}"
                              *ngIf=" list?.label?.displayname =='Events'">{{list?.label?.displayname}}</p>
                            <p [ngClass]="{'bg-light-danger badge ': list?.label?.displayname =='Leave'}"
                              *ngIf="list?.label?.displayname =='Leave'">{{list?.label?.displayname}}</p>
                            <p [ngClass]="{'bg-light-primary badge': list?.label?.displayname =='Demo'}"
                              *ngIf="list?.label?.displayname =='Demo'">{{list?.label?.displayname}}</p>
  
                            <p class="font-medium-1 line-height-1 mb-2 cursor-pointer"
                              (click)="openModalUpdate(adminNotesModal,row?._id,row?.admin_notes,'admin_notes')">{{row?.title}}</p>
                            <div class="users-box ">
                              <div class="text-muted font-small-2 " *ngFor="let user of row?.to">
                                <span class="bg-light-primary badge badge-pill cursor-pointer"
                                  (click)="openModalEmp(myModal,row?.to,row?._id)"> {{user?.name}}</span>
                              </div>
                            </div>
                            <div class="users-box ">
                              <div [matMenuTriggerFor]="task_priority" class="text-muted font-small-2"
                                *ngFor="let priority of row?.priority">
                                <span *ngIf="priority?.displayname =='Normal'" class="bg-light-info badge badge-pill cursor-pointer">
                                  {{priority?.displayname}}</span>
                                <span *ngIf="priority?.displayname =='Medium'" class="bg-light-warning badge badge-pill cursor-pointer">
                                  {{priority?.displayname}}</span>
                                <span *ngIf="priority?.displayname =='High'" class="bg-light-danger badge badge-pill cursor-pointer">
                                  {{priority?.displayname}}</span>
                                <span *ngIf="priority?.displayname =='Urgent'" class="bg-light-danger badge badge-pill cursor-pointer">
                                  {{priority?.displayname}}</span>
                              </div>
                             
                              <mat-menu #task_priority="matMenu">
  
                                <div>
                                  <div *ngFor="let priority of task_priority_List">
                                    <button mat-menu-item *ngIf="priority?.displayname !== row?.priority[0]?.displayname"
                                      (click)="updatePrority(row?._id,priority._id)">
                                      <span>
                                        <span
                                          [ngClass]="{'bg-light-info badge badge-pill':priority.displayname == 'Normal'}"
                                          placement="top"
                                          *ngIf="priority.displayname == 'Normal'">{{priority.displayname}}</span>
                                        <span
                                          [ngClass]="{'bg-light-warning badge badge-pill':priority.displayname == 'Medium'}"
                                          placement="top"
                                          *ngIf="priority.displayname == 'Medium'">{{priority.displayname}}</span>
                                        <span
                                          [ngClass]="{'bg-light-danger badge badge-pill':priority.displayname == 'High'}"
                                          placement="top"
                                          *ngIf="priority.displayname == 'High'">{{priority.displayname}}</span>
                                        <span
                                          [ngClass]="{'bg-light-danger badge badge-pill':priority.displayname == 'Urgent'}"
                                          placement="top"
                                          *ngIf="priority.displayname == 'Urgent'">{{priority.displayname}}</span>
                                      </span>
                                    </button>
                                  </div>
                                 
                                </div>
                              </mat-menu>
  
                            </div>
                            <div class="users-box">
                              <p class="schedule-box badge badge-pill">{{row?.is_schedule}}</p>
                            </div>
                          </div>
  
                        </div>
                      </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Body" prop="body" [width]="150">
                      <ng-template let-rowIndex="rowIndex" let-row="row" let-name="value" ngx-datatable-cell-template>
                        <!-- <div title="Double click to edit task-box" (dblclick)="editing[rowIndex + '-body'] = true"
                              *ngIf="!editing[rowIndex + '-body']">
                                <div>
                                  <span class="current-task-box" *ngIf="row?.body" [innerText]="row?.body"></span>                 
                                  <span *ngIf="!row?.body || row?.body =='\n'">
                                    <i class="ft-plus text-primary cursor-pointer" placement="right" ngbTooltip="add new"></i>
                                  </span>
                                </div>
                              </div>   
                              <div>
                                <textarea autofocus class="form-control form-control-sm"
                                (blur)="inlineEditingUpdate($event,'body',rowIndex,row?.body,row?._id)"
                                *ngIf="editing[rowIndex + '-body']" type="text" cols="30" rows="1"
                                [(ngModel)]="row.body"></textarea>
                              </div>   -->
                        <div>
                          <div class="d-flex">
                            <span class="current-task-box" *ngIf="row?.body" [innerHtml]="row?.body"></span>
                            <span *ngIf="!row?.body || row?.body =='\n'">
                              <i class="ft-plus text-primary cursor-pointer"
                                (click)="openModalUpdate(myModal3,row?._id,row?.body,'body')" placement="right"
                                ngbTooltip="add new"></i>
                            </span>
                            <span class="ml-2"  *ngIf="row?.body" > <i  (click)="openModalUpdate(myModal3,row?._id,row?.body,'body')"
                                class="ft-edit text-primary cursor-pointer"></i> </span>
                          </div>
                        
                        </div>
                      </ng-template>
                    </ngx-datatable-column>
                    <!-- <ngx-datatable-column name="Assign To" prop="name" [width]="200">
                          <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                              <p class="font-medium-1 line-height-1 mb-0" *ngFor="let user of row?.to; last as isLast">
                                  <span>{{user?.name}}</span>
                                  <span *ngIf=" row?.to.length >1 && !isLast">,</span>
                              </p>
                          </ng-template>
                      </ngx-datatable-column> -->
                    <ngx-datatable-column name="Notes" prop="notes" [width]="150">
                      <ng-template let-rowIndex="rowIndex" let-row="row" let-name="value" ngx-datatable-cell-template>
                        <!-- <div title="Double click to edit task-box" (dblclick)="editing[rowIndex + '-notes'] = true"
                          *ngIf="!editing[rowIndex + '-notes']">
                          <div>
                            <span class="current-task-box" *ngIf="row?.notes" [innerText]="row?.notes"></span>
                            <span *ngIf="!row?.notes || row?.notes =='\n'">
                              <i class="ft-plus text-primary cursor-pointer" placement="right" ngbTooltip="add new"></i>
                            </span>
                          </div>
                        </div>
                        <div>
                          <textarea autofocus class="form-control form-control-sm"
                            (blur)="inlineEditingUpdate($event,'notes',rowIndex,row?.notes,row?._id)"
                            *ngIf="editing[rowIndex + '-notes']" type="text" cols="30" rows="1"
                            [(ngModel)]="row.notes"></textarea>
                        </div> -->
                        <div>
                          <div class="d-flex">
                            <span class="current-task-box" *ngIf="row?.notes" [innerHtml]="row?.notes"></span>
                            <span *ngIf="!row?.notes || row?.notes =='\n'">
                              <i class="ft-plus text-primary cursor-pointer"
                                (click)="openModalUpdate(myModal3,row?._id,row?.notes,'notes')" placement="right"
                                ngbTooltip="add new"></i>
                            </span>
                            <span class="ml-2" *ngIf="row?.notes"> <i  (click)="openModalUpdate(myModal3,row?._id,row?.notes,'notes')"
                                class="ft-edit text-primary cursor-pointer"></i> </span>
                            <span class="mx-1">
                            </span>
                          </div>
                          
                        </div>
  
                      </ng-template>
                    </ngx-datatable-column>
                    <!-- <ngx-datatable-column name="Priority" prop="priority" [width]="40">
                          <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                              {{row?.priority[0]?.displayname}}                            
                          </ng-template> 
                      </ngx-datatable-column> -->
                    <!-- <ngx-datatable-column name="Is Mandatory " prop="is_mandatory " [width]="40">
                          <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                            <span *ngIf="row?.is_mandatory =='no'" [ngClass]="{ 'bg-light-info badge badge-pill ':row?.is_mandatory =='no'}">{{row?.is_mandatory }}</span>  
                            <span *ngIf="row?.is_mandatory =='yes'" [ngClass]="{ 'bg-light-danger badge badge-pill ':row?.is_mandatory =='yes'}">{{row?.is_mandatory }}</span>                           
                          </ng-template> 
                      </ngx-datatable-column> -->
                    <!-- <ngx-datatable-column name="Due Date" prop="scheduleduration" [width]="40">
                      <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                        {{row?.due_date |date :'mediumDate'}}
                      </ng-template>
                    </ngx-datatable-column> -->
  
                    <ngx-datatable-column name="Actions" [width]="10">
  
                      <ng-template let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template>
                        <div class="mb-1" [ngClass]="{'bg-light-danger': row?.due_date < today_date , 'bg-light-success': row?.due_date > today_date }">{{row?.due_date | date:'mediumDate'}}</div>
                        <div>
                          <i mat-button [matMenuTriggerFor]="menu" class="ft-more-vertical text-primary cursor-pointer mr-2"></i>
                          <i mat-button [matMenuTriggerFor]="menu2" class="ft-settings text-primary cursor-pointer mr-2"></i>
                          <i class="ft-copy my-1 primary cursor-pointer" (click)="copyItem(row?._id)"></i>
                        
                        </div>
                        <div class="users-box">
                          <p  mat-button [matMenuTriggerFor]="stageMenu">
                            
                            <span [ngClass]="{'badge badge-pill bg-light-success':row?.stage[0]?.displayname =='Completed'}" *ngIf="row?.stage[0]?.displayname =='Completed'">{{row?.stage[0]?.displayname}}</span>
                            <span [ngClass]="{'badge badge-pill bg-light-danger':row?.stage[0]?.displayname =='Backlog'}" *ngIf="row?.stage[0]?.displayname =='Backlog'">{{row?.stage[0]?.displayname}}</span>
                            <span [ngClass]="{'badge badge-pill bg-light-warning':row?.stage[0]?.displayname =='In-Review'}" *ngIf="row?.stage[0]?.displayname =='In-Review'">{{row?.stage[0]?.displayname}}</span>
                            <span [ngClass]="{'badge badge-pill bg-light-primary':row?.stage[0]?.displayname =='Current'}" *ngIf="row?.stage[0]?.displayname =='Current'">{{row?.stage[0]?.displayname}}</span>
  
                          </p>
                        </div>
  
                        <mat-menu #stageMenu="matMenu">
                          <div *ngFor="let stage of stage_list">
                            <button class="btn mb-1" style="width: 100%;" [ngClass]="{'bg-light-success':stage.displayname =='Completed','bg-light-danger':stage.displayname =='Backlog',
                            'bg-light-warning':stage.displayname =='In-Review','bg-light-primary':stage.displayname =='Current'}" *ngIf="stage.displayname !=row?.stage[0]?.displayname"
                            (click)="updateStage(row?._id,stage?._id)" >{{stage.displayname}}</button >
                          </div>
                        </mat-menu>
  
                        <mat-menu #menu="matMenu">
                          <div>
                            <button (click)="taskEdit(addCheckListModal,row?._id)" class="btn mb-1"
                              style="width: 100%;">Edit</button>
                            <button class="btn bg-light-danger" style="width: 100%;" (click)="ConfirmDelete(row._id,rowIndex)">Delete</button>
                          </div>
                          
                          
                        </mat-menu>
                        <mat-menu #menu2="matMenu">
                        <div *ngFor="let status of task_status_list">
                          <button class="btn" style="width: 100%;" (click)="updateStatus(row?._id,status?._id)" *ngIf="activeTab != status?.name">{{status?.displayname}}</button>
                        </div>
                        </mat-menu>
                      </ng-template>
                    </ngx-datatable-column>
  
                    <!-- <ngx-datatable-column name="Actions" [width]="40"
                          *ngIf=" user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
                          <ng-template let-row="row" ngx-datatable-cell-template>
                            <i class="ft-plus text-primary cursor-pointer" placement="right"
                            ngbTooltip="add badge" (click)="openModal(myModal,row?._id)"></i> -->
                    <!-- <i class="ft-edit text-primary cursor-pointer mr-2"
                              [routerLink]="['/employees/edit',row?.user?._id]"></i>
                            <i *ngIf="user_role.roles =='admin'" class="ft-trash-2 cursor-pointer danger"
                              (click)="Delete(row._id)"></i>
                            <i class="ft-copy text-primary cursor-pointer ml-2 mr-2" placement="top"
                              ngbTooltip="Copy Default Password" (click)="copyToClipboard(row?.user?.name,row?.user?.phone)"></i>
                            <i *ngIf="user_role.roles =='admin'" class="icon-key text-primary cursor-pointer" placement="top"
                              ngbTooltip="set default password" (click)="setDefaultPassword(row?.user?._id, row?.user?.name)"></i> -->
                    <!-- </ng-template>
                        </ngx-datatable-column> -->
                  </ngx-datatable>
              </div>
              <!-- ngx-datatable-filter -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!--/ Filter Datatables -->
  <div class="d-flex justify-content-between align-items-center">
    <ngx-spinner></ngx-spinner>
  </div>
  
  <!--------- -->
  
  <div>
    <ng-template #myModal let-modal>
      <div class="modal-header">
        <h4 class="modal-title">Ownership Update</h4>
        <button type="button" class="close" (click)="modal.dismiss()">
          <span>&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <ng-select [items]="empList" bindLabel="name" bindValue="_id" placeholder="Select Employee"
          [(ngModel)]="selectedEmp" [multiple]="true" [ngModelOptions]="{ standalone: true }" (change)="getEmpId($event)"
          [appendTo]="'body'" [virtualScroll]="true" [clearSearchOnAdd]="true">
        </ng-select>
  
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="updateAssignTo()">Submit</button>
      </div>
    </ng-template>
  </div>
  
  <!-------- Add New Checklist Popup ----------------------->
  
  
  <div>
    <ng-template #addCheckListModal let-modal>
      <div class="modal-header">
        <h3 *ngIf="!task_id">Create Task</h3>
        <h3 *ngIf="task_id">Update Task</h3>
  
        <button type="button" class="close" (click)="modal.dismiss()">
          <span>&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="modal-body taskboard-modal">
          <form [formGroup]="myForm">
            <div class="container">
  
              <fieldset class="form-group position-relative has-icon-left">
                <ng-select [items]="empList" bindLabel="name" bindValue="_id" placeholder="Select Employee"
                  [(ngModel)]="selectedEmp" [multiple]="true" [closeOnSelect]="false"
                  [ngModelOptions]="{ standalone: true }" (open)="onDropdownOpenEmp($event)"
                  (close)="onDropdownCloseEmp($event)">
                  <ng-template ng-header-tmp>
                    <div class="checkbox-container">
                      <input type="checkbox" [(ngModel)]="isAllSelected" [ngModelOptions]="{standalone: true}"
                        (click)="toggleAllSelectionEmp()">
                      <span>Select All</span>
                    </div>
                  </ng-template>
  
                  <ng-template ng-option-tmp let-item="item">
                    <div class="checkbox-container">
                      <input type="checkbox" [(ngModel)]="item.selected" [ngModelOptions]="{standalone: true}"
                        (change)="toggleSelectionEmp(item)">
                      <span>{{ item.name }}</span>
                    </div>
                  </ng-template>
                </ng-select>
              </fieldset>
              <fieldset class="form-group position-relative has-icon-left">
                <ng-select *ngIf="task_model ==''" [items]="check_list" bindLabel="displayname" bindValue="_id"
                  placeholder="Select check" [multiple]="true" [(ngModel)]="selected_check"
                  [ngModelOptions]="{ standalone: true }" (change)="getCheckListId($event)">
                </ng-select>
                <ng-select *ngIf="task_model !=''" [items]="check_list" bindLabel="displayname" bindValue="_id"
                  placeholder="Select check" [(ngModel)]="selected_check" [ngModelOptions]="{ standalone: true }"
                  (change)="getCheckListId($event)">
                </ng-select>
              </fieldset>
              <fieldset class="form-group position-relative has-icon-left">
                <ng-select [items]="taskLabelList" bindLabel="displayname" bindValue="_id" placeholder="Select TaskLabel"
                  [(ngModel)]="selected_task_label" [ngModelOptions]="{ standalone: true }"
                  (change)="getChangeTaskLabelId($event)">
                </ng-select>
  
              </fieldset>
              <fieldset class="form-group position-relative has-icon-left">
                <div class="form-control-position">
                  <i class="ft-edit-2"></i>
                </div>
                <input type="text" formControlName="title" [(ngModel)]="task_model.title" class="form-control"
                  id="todoTitle" placeholder="Title" (keydown.enter)="$event.preventDefault()" required #todoTitle>
                <div class="form-control-position control-position-right">
                  <i class="ft-edit-2"></i>
                </div>
              </fieldset>
              <fieldset class="form-group position-relative has-icon-left">
                <!-- <div class="form-control-position">
                  <i class="ft-message-square"></i>
                </div> -->
                <label>Body</label>
                <quill-editor (onContentChanged)="inlineAddupdateBody(task_model.body,'body')"
                  [(ngModel)]="task_model.body" [ngModelOptions]="{standalone: true}" [modules]="{toolbar: false}">
                </quill-editor>
                <!-- <textarea formControlName="body" [(ngModel)]="task_model.body" class="form-control" placeholder="body">
                
              </textarea> -->
              </fieldset>
              <fieldset>
                <ng-select [items]="scheduleList" bindLabel="name" bindValue="id" placeholder="Select Schedule"
                  [(ngModel)]="selectedSchedule" [ngModelOptions]="{ standalone: true }"
                  (change)="getScheduleId($event)">
                </ng-select>
              </fieldset>
  
              <fieldset class="form-group position-relative has-icon-left mt-2">
                <div class="form-control-position">
                  <i class="fa-regular fa-calendar-days"></i>
                </div>
                <input *ngIf="!task_id" type="date" formControlName="due_date" [(ngModel)]="current_date"
                  class="form-control">
                  <input *ngIf="task_id" type="date" formControlName="due_date" [(ngModel)]="task_model.due_date" class="form-control">
                <div class="form-control-position control-position-right">
                  <i class="fa-regular fa-calendar-days"></i>
                </div>
              </fieldset>
              <fieldset class="form-group position-relative has-icon-left mt-2">
                <div class="form-control-position">
                  <i class="ft-clock"></i>
                </div>
                <input *ngIf="!task_model.working_hours" type="text" formControlName="time" [(ngModel)]="time"
                  class="form-control">
                <input *ngIf="task_model.working_hours" type="text" formControlName="time"
                  [(ngModel)]="task_model.working_hours" class="form-control">
  
                <div class="form-control-position control-position-right">
                  <i class="ft-clock"></i>
                </div>
              </fieldset>
              <fieldset class="form-group position-relative has-icon-left mt-2">
                <div class="form-control-position">
                  <i class="ft-dollar-sign"></i>
                </div>
                <input *ngIf="!task_model.budget" type="text" formControlName="budget" [(ngModel)]="budget_val"
                  class="form-control" placeholder="Enter budget">
                <input *ngIf="task_model.budget" type="text" formControlName="budget" [(ngModel)]="task_model.budget"
                  class="form-control" placeholder="Enter budget">
                <div class="form-control-position control-position-right">
                  <i class="ft-dollar-sign"></i>
                </div>
              </fieldset>
              <fieldset class="form-group position-relative has-icon-left">
                <!-- <div class="form-control-position">
                  <i class="ft-message-square"></i>
                </div>
                <textarea formControlName="notes" [(ngModel)]="task_model.notes" class="form-control" placeholder="notes">
                <div class="form-control-position control-position-right">
                  <i class="ft-message-square"></i>
                </div>
              </textarea> -->
              <label>Notes</label>
              <quill-editor (onContentChanged)="inlineAddupdateBody(task_model.notes,'notes')" [(ngModel)]="task_model.notes"
                [ngModelOptions]="{standalone: true}" [modules]="{toolbar: false}">
              
              </quill-editor>
              </fieldset>
              <fieldset class="form-group position-relative has-icon-left">
                <!-- <div class="form-control-position">
                  <i class="ft-message-square"></i>
                </div>
                <textarea formControlName="admin_notes" [(ngModel)]="task_model.admin_notes" class="form-control"
                  placeholder="guidelines">
                <div class="form-control-position control-position-right">
                  <i class="ft-message-square"></i>
                </div>
              </textarea> -->
              <label>Guidelines</label>
              <quill-editor (onContentChanged)="inlineAddupdateBody(task_model.admin_notes,'admin_notes')" [(ngModel)]="task_model.admin_notes"
                [ngModelOptions]="{standalone: true}" [modules]="{toolbar: false}">
              
              </quill-editor>
              </fieldset>
            </div>
          </form>
  
        </div>
      </div>
      <div class="modal-footer">
        <!-- <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button> -->
        <button *ngIf="!task_id " type="button" class="btn btn-primary" (click)="createTask()">Create</button>
        <button *ngIf="task_id " type="button" class="btn btn-primary" (click)="submit()">Update</button>
      </div>
    </ng-template>
  </div>
  
  <!----- Admin Notes / Guideline Update Popup -->
  
  <div class=" modal-Admin-Notes">
    <ng-template #adminNotesModal let-modal>
      <div class=" modal-Admin-Notes">
      <div class="modal-header">
        <h4 class="modal-title">Guidelines</h4>
        <button type="button" class="close" (click)="modal.dismiss()">
          <span>&times;</span>
        </button>
      </div>
      <div class="modal-body">
       
        <div>
          <div class="d-flex" >
            <span class="current-task-box" *ngIf="!isEditor && update_row_data" [innerHtml]="update_row_data"></span>
            <span *ngIf="!update_row_data  ">
              <i (click)="isEditor =!isEditor" class="ft-plus text-primary cursor-pointer" 
                placement="right" ngbTooltip="add new"></i>
            </span>
            <span class="ml-2" *ngIf="update_row_data"> <i (click)="isEditor =!isEditor" class="ft-edit text-primary cursor-pointer"></i> </span>
          </div>
          <div *ngIf="isEditor">
            <quill-editor (onEditorCreated)="setFocus($event)" (onContentChanged)="inlineEditing(update_row_data)"
              [(ngModel)]="update_row_data"></quill-editor>
          </div>
        
        </div>
  
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="submitEditData()">Submit</button>
      </div>
      </div>
    </ng-template>
  </div>
  
  <!-------- Update Task Body Or Notes -->
  
  <div>
    <ng-template #myModal3 let-modal>
      <div class="modal-header">
        <h4 class="modal-title" *ngIf="isReadOnly">Add</h4>
        <h4 class="modal-title" *ngIf="!isReadOnly">Update</h4>
  
        <button type="button" class="close" (click)="modal.dismiss()">
          <span>&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="text-editor">
        <quill-editor (onEditorCreated)="setFocus($event)" (onContentChanged)="inlineEditing(update_row_data)"
          [(ngModel)]="update_row_data"></quill-editor>
        </div>
       
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="submitEditData()">Submit</button>
      </div>
    </ng-template>
  </div>
  
  